// HTTP wrapper for the MySQL server-side user management endpoints.
// Admin-only on the backend.
import { api } from './api.js';

export async function listMySQLUsers(connectionId) {
  const r = await api.get(`/api/connections/${connectionId}/mysql-users`);
  // plugins/defaultPlugin: the server's caps-filtered auth-plugin list, so the
  // dialog never offers a plugin this server version rejects (e.g.
  // mysql_native_password is gone on MySQL 8.4+/9, caching_sha2_password
  // doesn't exist on MariaDB).
  return {
    users: r.users || [],
    plugins: r.plugins || ['mysql_native_password'],
    defaultPlugin: r.defaultPlugin || 'mysql_native_password',
  };
}

export async function createMySQLUser(connectionId, { user, host, plugin, password }) {
  return api.post(`/api/connections/${connectionId}/mysql-users`,
    { user, host, plugin, password });
}

// User and host are part of the path; PATCH body carries the changes.
export async function editMySQLUser(connectionId, user, host, body) {
  return api.patch(
    `/api/connections/${connectionId}/mysql-users/${encodeURIComponent(user)}/${encodeURIComponent(host)}`,
    body,
  );
}

export async function dropMySQLUser(connectionId, user, host) {
  return api.delete(
    `/api/connections/${connectionId}/mysql-users/${encodeURIComponent(user)}/${encodeURIComponent(host)}`,
  );
}

// Grants live under the user/host path. GET returns
// { grants:{global,databases}, catalog:{global,database}, databases:[…], raw:[…] };
// PUT takes a GrantInfo { global:{privileges,grantOption}, databases:{db:{…}} }.
const grantsUrl = (connectionId, user, host) =>
  `/api/connections/${connectionId}/mysql-users/${encodeURIComponent(user)}/${encodeURIComponent(host)}/grants`;

export async function getUserGrants(connectionId, user, host) {
  return api.get(grantsUrl(connectionId, user, host));
}

export async function setUserGrants(connectionId, user, host, grants) {
  return api.put(grantsUrl(connectionId, user, host), grants);
}
